module.exports = __webpack_public_path__ + "img/WomanChico.c7c38959.png";